import { render, staticRenderFns } from "./Grupos.vue?vue&type=template&id=e98532da&scoped=true"
import script from "./Grupos.vue?vue&type=script&lang=js"
export * from "./Grupos.vue?vue&type=script&lang=js"
import style0 from "./Grupos.vue?vue&type=style&index=0&id=e98532da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98532da",
  null
  
)

export default component.exports